import { getFieldValue, FUEL_TYPE_OPTIONS } from './FieldValueComponents'

/**
 * Component for rendering individual fuel log field columns
 * @param {Object} props - Component props
 * @param {Object} props.report - Report/form data
 * @param {boolean} props.isEditing - Whether row is in edit mode
 * @param {Object} props.editedValues - Edited field values
 * @param {Function} props.handleFieldChange - Callback to handle field value changes
 * @param {Array} props.FIELD_IDS - Array of field IDs to render
 * @returns {JSX.Element} Field columns
 */
const FuelLogFieldColumns = ({ report, isEditing, editedValues, handleFieldChange, FIELD_IDS }) => {
  const jobNumberFieldId = 'e2f5badc-d154-4c71-8ae2-1d8c678e3d7d'
  const fuelTypeFieldId = '55dbcda9-45db-4dfd-835b-f32e7e959368'

  return (
    <>
      {FIELD_IDS.map(fieldId => {
        const isJobNumberField = fieldId === jobNumberFieldId
        const currentLocationId = editedValues.locationId || ''
        const originalLocationId = editedValues._originalLocationId || ''
        const currentJobNumber = editedValues[jobNumberFieldId] || ''

        // Determine if Job Number field should be disabled
        // Rule 1: If both Location and Job# are not empty (originally), disable Job# editing
        // Rule 2: If Location is empty originally but Job# is filled, enable Job# ONLY if location field remains empty
        //         If location gets selected, Job# is disabled (and replaced with location name)
        const shouldDisableJobNumber = isJobNumberField && (
          // Rule 1: Both originally not empty
          (originalLocationId && currentJobNumber && currentJobNumber !== '—') ||
          // Rule 2: Location originally empty, job# filled, but NOW location is selected
          (!originalLocationId && currentJobNumber && currentJobNumber !== '—' && currentLocationId)
        )

        const fieldValue = getFieldValue(report, fieldId)

        return (
          <td key={fieldId} className="approval-summary-table" title={isEditing ? '' : fieldValue}>
            {isEditing ? (
              // Show dropdown for Fuel Type field
              fieldId === fuelTypeFieldId ? (
                <select
                  value={editedValues[fieldId] || ''}
                  onChange={(e) => handleFieldChange(fieldId, e.target.value)}
                  style={{
                    width: '100%',
                    padding: '6px 8px',
                    border: '1px solid #cbd5e1',
                    borderRadius: 4,
                    fontSize: '0.9rem',
                    backgroundColor: '#fff'
                  }}
                >
                  <option value="">Select Fuel Type</option>
                  {FUEL_TYPE_OPTIONS.map(fuelType => (
                    <option key={fuelType} value={fuelType}>
                      {fuelType}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={editedValues[fieldId] || ''}
                  onChange={(e) => handleFieldChange(fieldId, e.target.value)}
                  disabled={shouldDisableJobNumber}
                  style={{
                    width: '100%',
                    padding: '6px 8px',
                    border: '1px solid #cbd5e1',
                    borderRadius: 4,
                    fontSize: '0.9rem',
                    backgroundColor: shouldDisableJobNumber ? '#f3f4f6' : '#fff',
                    cursor: shouldDisableJobNumber ? 'not-allowed' : 'text',
                    opacity: shouldDisableJobNumber ? 0.6 : 1
                  }}
                />
              )
            ) : (
              <span className="approval-summary-td-content">{fieldValue}</span>
            )}
          </td>
        )
      })}
    </>
  )
}

export default FuelLogFieldColumns
